module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


/*****************
 ** WEBPACK FOOTER
 ** external "Raphael"
 ** module id = 15
 ** module chunks = 0
 **/